import { render, staticRenderFns } from "./FooterComponentJobtalent.vue?vue&type=template&id=15e06d10&scoped=true"
import script from "./FooterComponentJobtalent.vue?vue&type=script&lang=ts"
export * from "./FooterComponentJobtalent.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentJobtalent.vue?vue&type=style&index=0&id=15e06d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e06d10",
  null
  
)

export default component.exports